import * as UnitLight from 'types/Unit/UnitLight';

export type Type = UnitLight.Type[];

export type objectWithId = { id: string };

export function create(): Type {
	return [];
}

export function getUnitSuggestions(inUse: objectWithId[], allUnits: Type): Type {
	const output = allUnits.filter((e: UnitLight.Type) => {
		if (!inUse.map((e: objectWithId) => e.id).includes(e.id)) {
			return e;
		}
	});
	return output;
}
